@if (embedded) {
<div class="user-embedded">
    <button type="button" class="sidebar-account-action" (click)="openEditCompanyProfile()">
        <mat-icon
            class="icon-size-5 sidebar-account-action-icon"
            [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>Profile</span>
    </button>
    <button type="button" class="sidebar-account-action" (click)="openChangePassword()">
        <mat-icon
            class="icon-size-5 sidebar-account-action-icon"
            [svgIcon]="'heroicons_outline:key'"></mat-icon>
        <span>Change Password</span>
    </button>
    <button type="button" class="sidebar-account-action" (click)="lockScreen()">
        <mat-icon
            class="icon-size-5 sidebar-account-action-icon"
            [svgIcon]="'heroicons_outline:lock-closed'"></mat-icon>
        <span>Lock screen</span>
    </button>
    @if (canOpenCompanySettings) {
        <button type="button" class="sidebar-account-action" (click)="openSettings()">
            <mat-icon
                class="icon-size-5 sidebar-account-action-icon"
                [svgIcon]="'heroicons_outline:cog-8-tooth'"></mat-icon>
            <span>Settings</span>
        </button>
    }
    @if (canViewActivityLogs) {
        <button type="button" class="sidebar-account-action" (click)="openActivityLogs()">
            <mat-icon
                class="icon-size-5 sidebar-account-action-icon"
                [svgIcon]="'heroicons_outline:clipboard-document-list'"></mat-icon>
            <span>Activity Logs</span>
        </button>
    }
    @if (canOpenMyHome) {
        <button type="button" class="sidebar-account-action" (click)="openMyHome()">
            <mat-icon
                class="icon-size-5 sidebar-account-action-icon"
                [svgIcon]="'heroicons_outline:home-modern'"></mat-icon>
            <span>My Home</span>
        </button>
    }
    @if (canViewPhoneDirectory) {
        <button type="button" class="sidebar-account-action" (click)="openPhoneDirectory()">
            <mat-icon
                class="icon-size-5 sidebar-account-action-icon"
                [svgIcon]="'heroicons_outline:phone'"></mat-icon>
            <span>Phone Directory</span>
        </button>
    }
    @if (canManageSessions) {
        <button type="button" class="sidebar-account-action" (click)="openSessionManagement()">
            <mat-icon
                class="icon-size-5 sidebar-account-action-icon"
                [svgIcon]="'heroicons_outline:computer-desktop'"></mat-icon>
            <span>Session management</span>
        </button>
    }
    @if (canAccessSupport) {
        <button type="button" class="sidebar-account-action" (click)="openSupport()">
            <mat-icon
                class="icon-size-5 sidebar-account-action-icon"
                [svgIcon]="'heroicons_outline:lifebuoy'"></mat-icon>
            <span>Support</span>
        </button>
    }
    <div class="sidebar-account-divider"></div>
    <button type="button" class="sidebar-account-action" (click)="signOut()">
        <mat-icon
            class="icon-size-5 sidebar-account-action-icon"
            [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
        <span>Sign out</span>
    </button>
</div>
} @else {
<!-- Button -->
<button
    mat-icon-button
    class="user-header-trigger"
    [matMenuTriggerFor]="userActions"
    aria-label="Account menu">
    <span class="user-header-avatar">
        <span class="user-header-avatar-clip">
            @if (showAvatar && avatarUrl) {
                <img
                    class="user-header-avatar-image"
                    [class.user-header-avatar-image--contain]="isCompanyLogoFallback"
                    [src]="avatarUrl"
                    [alt]="isCompanyLogoFallback ? 'Company logo' : 'User profile'"
                />
            } @else {
                <mat-icon
                    class="user-header-avatar-fallback"
                    [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
            }
        </span>
        <span
            class="user-header-avatar-status"
            [ngClass]="{
                'user-header-avatar-status--icon': !showAvatar || !avatarUrl,
                'bg-green-500': user?.status === 'online',
                'bg-amber-500': user?.status === 'away',
                'bg-red-500': user?.status === 'busy',
                'bg-gray-400': user?.status === 'not-visible',
            }"
        ></span>
    </span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>Signed in as</span>
            <span class="mt-1.5 text-md font-medium">{{ user?.email }}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="openEditCompanyProfile()">
        <mat-icon
            class="icon-size-4"
            [svgIcon]="'heroicons_outline:user-circle'"
        ></mat-icon>
        <span>Profile</span>
    </button>
    <button mat-menu-item (click)="openChangePassword()">
        <mat-icon
            class="icon-size-4"
            [svgIcon]="'heroicons_outline:key'"
        ></mat-icon>
        <span>Change Password</span>
    </button>
    <button mat-menu-item (click)="lockScreen()">
        <mat-icon
            class="icon-size-4"
            [svgIcon]="'heroicons_outline:lock-closed'"
        ></mat-icon>
        <span>Lock screen</span>
    </button>
    @if (canOpenCompanySettings) {
        <button mat-menu-item (click)="openSettings()">
            <mat-icon
                class="icon-size-4"
                [svgIcon]="'heroicons_outline:cog-8-tooth'"
            ></mat-icon>
            <span>Settings</span>
        </button>
    }
    @if (canViewActivityLogs) {
        <button mat-menu-item (click)="openActivityLogs()">
            <mat-icon
                class="icon-size-4"
                [svgIcon]="'heroicons_outline:clipboard-document-list'"
            ></mat-icon>
            <span>Activity Logs</span>
        </button>
    }
    @if (canOpenMyHome) {
        <button mat-menu-item (click)="openMyHome()">
            <mat-icon
                class="icon-size-4"
                [svgIcon]="'heroicons_outline:home-modern'"
            ></mat-icon>
            <span>My Home</span>
        </button>
    }
    @if (canViewPhoneDirectory) {
        <button mat-menu-item (click)="openPhoneDirectory()">
            <mat-icon
                class="icon-size-4"
                [svgIcon]="'heroicons_outline:phone'"
            ></mat-icon>
            <span>Phone Directory</span>
        </button>
    }
    @if (canManageSessions) {
        <button mat-menu-item (click)="openSessionManagement()">
            <mat-icon
                class="icon-size-4"
                [svgIcon]="'heroicons_outline:computer-desktop'"
            ></mat-icon>
            <span>Session management</span>
        </button>
    }
    @if (canAccessSupport) {
        <button mat-menu-item (click)="openSupport()">
            <mat-icon
                class="icon-size-4"
                [svgIcon]="'heroicons_outline:lifebuoy'"
            ></mat-icon>
            <span>Support</span>
        </button>
    }
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="signOut()">
        <mat-icon
            class="icon-size-4"
            [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"
        ></mat-icon>
        <span>Sign out</span>
    </button>
</mat-menu>
}
